import { Box, Container, CircularProgress, GridLegacy as Grid } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { Link } from "@/compat/router";
import { useTracking } from "react-tracking";
import PageBase from "../components/PageBase";
import Epic from "./Epic";
import useKnowledgeBank from "../hooks/queries/useKnowledgeBank";

const useStyles = makeStyles((theme) => ({
    panel: {
        border: '1px solid #bfbfbf',
        borderRadius: '5px',
        padding: '10px',
        height: '100%'
    },
    title: {
        background: theme.palette.title.background,
        color: theme.palette.title.text,
        padding: '2px 8px',
        borderRadius: '5px',
        width: 'inherit'
    },
    tileContent: {
        textOverflow: 'ellipsis',
        xheight: '30px',
        xmaxHeight: '25px',
        overflow: 'hidden',
        display: "-webkit-box",
        WebkitLineClamp: 3,
        WebkitBoxOrient: "vertical",
    },

}));

const Categories = () => {
    const classes = useStyles();
    const { Track } = useTracking({
        page: 'KnowledgeBank-Categories'
    });

    const { data, isLoading } = useKnowledgeBank();   

    const primaryCategories = data?.primaryCategories;

    if (isLoading)
        return (
            <Box display="flex" width="100%" justifyContent="center">
                <CircularProgress />
            </Box>
        );

    return (
        <PageBase>
            <Track>
                <Container>
                    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" gap="15px">
                        <Epic
                            title="Categories"
                            main="Lorem ipsum ..."
                        />
                        <Grid container spacing={2}>                            
                            {primaryCategories.map(c =>
                                <Grid item xs={12} md={4} key={c.id}>
                                    <Link key={c.id} to={`/knowledge/category/${c.name.replaceAll(" ", "_")}`}>
                                        <img width="100%" alt={c.name} src={`${process.env.PUBLIC_URL}/images/hrs_categories/${c.name.toLowerCase().replaceAll(" ", "-")}-large.gif`}></img>
                                    </Link>    
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                </Container>
            </Track>
        </PageBase>
    );
}

export default Categories;
